import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        Below you will find user guides designed to aid licensing and
        registration portal navigation and application procedures:
      </Typography>
      <Typography component={Box}>
        <ul>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-ACCOUNT_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Account Access and Management
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-AGENT_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Agent Credentialing
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-BUSINESS_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Cannabis Business Accounts, New Applications, and
              Renewal Applications
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-BUSINESS_UPDATE_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Cannabis Business Updates
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-INVOICES_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide to Access Invoices for Agents and Businesses
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-PRODUCT_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Product Registrations
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href={`${process.env.PUBLIC_URL}/resources/IL-DOA-INDUSTRY-VEHICLE_GUIDE.pdf`}
              rel="noopener noreferrer"
            >
              User Guide for Vehicle Registrations
            </a>
          </li>
          {/* <li>
            <a href="mailto:AGR.adultuse@illinois.gov">
              AGR.adultuse@illinois.gov
            </a>
          </li> */}
        </ul>
      </Typography>

      <Typography>
        For regulatory-related questions, please visit the Illinois Department
        of Agriculture&apos;s{" "}
        <a
          href="https://cannabis.illinois.gov/agencies/cannabis-idoa/contact-us.html"
          target="_top"
        >
          Division of Cannabis Regulation Contact Us
        </a>{" "}
        page.
      </Typography>
      <Typography>
        For technical support, please contact Tyler Cannabis Licensing Support
        at{" "}
        <a
          href="https://cannabislicensing.zendesk.com/hc/en-us/requests/new"
          target="_top"
        >
          https://cannabislicensing.zendesk.com/hc/en-us/requests/new
        </a>
        .
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
